import { useEffect } from 'react';
import { DEFAULT_BRANDING } from '../constants';

/**
 * Hook pour modifier dynamiquement le favicon
 * @param faviconUrl - URL du favicon à utiliser (utilise le défaut si non spécifié)
 */
export function useFavicon(faviconUrl?: string) {
  useEffect(() => {
    const url = faviconUrl || DEFAULT_BRANDING.favicon;

    // Trouver ou créer l'élément link pour le favicon
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    // Mettre à jour l'URL du favicon
    link.href = url;

    // Cleanup: restaurer le favicon par défaut au démontage
    return () => {
      if (link) {
        link.href = DEFAULT_BRANDING.favicon;
      }
    };
  }, [faviconUrl]);
}
